import { SVGProps } from 'react';
const SvgArrowUpLeftLg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19 19 5 5M5 13V5h8"
    />
  </svg>
);
export default SvgArrowUpLeftLg;
